import { render, staticRenderFns } from "./CardapioCarrinhoTuor.vue?vue&type=template&id=6beac7c8&scoped=true&"
import script from "./CardapioCarrinhoTuor.vue?vue&type=script&lang=js&"
export * from "./CardapioCarrinhoTuor.vue?vue&type=script&lang=js&"
import style0 from "./CardapioCarrinhoTuor.vue?vue&type=style&index=0&id=6beac7c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beac7c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VSelect,VTextField})
